import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import useStyles from './UspBanner.styles';
const UspBanner = (props) => {
    const { title } = props;
    const { classes } = useStyles();
    return (_jsx(_Fragment, { children: title && (_jsx("div", { className: classes.container, children: _jsx("div", { className: classes.brandUspImage, children: _jsx("div", { className: classes.brandTitle, children: title }) }) })) }));
};
export default UspBanner;
